import * as React from 'react';

import DefaultFallback from './default-fallback';

interface IErrorBoundaryState {
    error: boolean;
}

interface IErrorBoundary {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fallbackComponent?: React.ReactElement<any>;
}

class ErrorBoundary extends React.Component<IErrorBoundary, IErrorBoundaryState> {
    constructor(props: IErrorBoundary) {
        super(props);
        this.state = { error: false };
    }

    public componentDidCatch() {
        this.setState({
            error: true
        });
    }

    public render(): JSX.Element | React.ReactNode {
        const { fallbackComponent } = this.props;

        if (this.state.error) {
            return fallbackComponent || <DefaultFallback />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
